import React, { useEffect } from 'react';
import VoucherGroupTable from 'components/management/tables/VoucherCategoryTable';
import { useStoreWrapper } from 'stores/StoreHelper';
import { AdminVoucherCategoryDto, MessageListingDto } from 'services/data-contracts';
import VoucherCategoryView from 'components/management/modals/VoucherCategoryView';
import VoucherCategoryEdit from 'components/management/modals/VoucherCategoryEdit';
import { useLocation } from 'react-router-dom';
import { getUrlParam } from 'libs/helper/utils';
import { observer } from 'mobx-react-lite';
import NoContents from 'components/commons/\bNoContents';
import MessageFilter from 'components/management/filters/MessageFilter';
import MessageTable from 'components/management/tables/MessageTable';
const MessagePage = observer(() => {
  const { uiStore } = useStoreWrapper();
  const { messageFilterStore } = useStoreWrapper();
  const location = useLocation();

  // const voucherGroups = ServiceHelper.getVoucherGroups();
  useEffect(() => {
    const search = getUrlParam('search');
    const page = getUrlParam('page');
    const size = getUrlParam('size');

    messageFilterStore.getMessages({
      keyword: search || '',
      page: page ? parseInt(page) : undefined,
      size: size ? parseInt(size) : 20,
    });
  }, [location.search]);

  const handleRowClick = (voucherCategory: AdminVoucherCategoryDto) => {
    uiStore?.modal.show({
      title: '바우처 그룹 상세',
      style: {
        maxWidth: '800px',
        height: 'auto',
        maxHeight: '80vh',
      },
      children: <VoucherCategoryView voucherCategory={voucherCategory} />,
    });
  };

  const handleEditClick = (voucherCategory?: AdminVoucherCategoryDto) => {
    const size = getUrlParam('size');
    uiStore?.modal.show({
      title: '바우처 그룹 수정',
      style: {
        maxWidth: '800px',
        height: '100%',
        maxHeight: '80vh',
      },
      children: <VoucherCategoryEdit voucherCategory={voucherCategory} />,
      onConfirmed: () => {
        messageFilterStore.getMessages({
          page: 0,
          size: size ? parseInt(size) : 20,
        });
      },
    });
  };

  return (
    <div>

      <MessageFilter onClickAdd={() => { handleEditClick() }} />
      <MessageTable messages={messageFilterStore?.messages}
        onRowClick={(row: MessageListingDto) => { handleRowClick(row) }}
        onEditClick={(row: MessageListingDto) => { handleEditClick(row) }} />
      <NoContents>
        표시할 데이터가 없습니다.
      </NoContents>
    </div>
  );
});

export default MessagePage;
